module.exports = __webpack_public_path__ + "static/media/addFriend.2a6e3181.png";